const emailSuporte = import.meta.env.VITE_APP_SUPORTE_AGNES || '';

export const ptBR = {
  commons: {
    search: {
      empty: 'Não há registros de {name} a serem exibidos.',
      filter: {
        empty: 'Nenhum registro foi encontrado com os critérios de busca.',
      },
    },
    atualizarColeta: {
      title: 'Atualizar dados',
      description: 'Selecione abaixo os empregadores que deseja realizar a coleta de dados da DCTF.',
      label: 'Empregadores',
      execute: 'Executar',
    },
    contactUs: 'Por favor, entre em contato através do chat para falar com nossa equipe.',
  },

  toast: {
    downloadSuccess: 'Download iniciado. Verifique o arquivo em seu computador.',
    downloadError: `{'Não foi possível iniciar o download. Por favor, tente novamente mais tarde. Se o problema persistir, entre em contato com o ${emailSuporte}.'}`,
    exportSuccess:
      'Sua solicitação de exportação foi recebida com sucesso! Faça o download assim que o arquivo estiver disponível no menu "Exportações" (<span class="material-symbols-outlined" style="font-size:16px">download_2</span>).',
    exportError: `<strong>Não foi possível processar sua solicitação de exportação.</strong> Por favor, tente novamente mais tarde. Se o problema persistir, entre em contato com o ${emailSuporte}.`,
  },

  company: {
    hintBotDays:
      'A configuração padrão para este campo é de 5 dias antes da data de vencimento da certidão vigente. Se precisar personalizar, especifique o número de dias para a coleta.',
    hintBotRetroactiveMonth:
      'A configuração padrão para este campo é de 60 meses. Se precisar personalizar, especifique o número de meses para a coleta retroativa.',
    hintBotRetroactiveDay:
      'A configuração padrão para este campo é de 18 dias. Se precisar personalizar, especifique o número de dias para a coleta retroativa.',
    hintBotSituacaoFiscal:
      'Requer uma outorga específica para ser concedida pelo cliente. A configuração padrão para este campo é sincronizar a coleta com a certidão federal. Se precisar personalizar, especifique a frequência de coleta.'
  },

  config: {
    noEmployerRegistered: 'Sua conta ainda não possui empregador(es) atribuído(s).',
  },

  trabalhador: {
    cbo: {
      tabRisco: {
        graficoExposicaoHelper:
          'O gráfico de riscos considera apenas os itens analisados e que possuem algum risco relacionado. Os itens com risco são distribuídos de acordo com o grau de risco, para mais detalhes quanto os critérios de classificação de risco acesse a matriz de exposição.',
      },
    },
    horariosJornada: {
      detalhes: {
        abas: {
          recomendacoes: {
            alerta:
              '<strong>Versões anteriores do eSocial!</strong> O evento S-1050, que era usado para cadastrar tabelas de horários/turnos de trabalho, não faz mais parte do leitaute do eSocial simplificado (versão S-1.0), que entrou em vigor em 2021.',
            notificacaoAnaliseInvalida:
              'Você sinalizou o item como analisado, no entanto, há campos de análise obrigatórios sem preenchimento. <br> Proceda com o preenchimento dos campos faltantes ou altere a etapa de análise se deseja salvar.',
            notificacaoAnaliseIncompleta:
              'Identificamos campos sem preenchimento <strong>({campos})</strong>, gostaria de continuar as análises e preencher os itens faltantes ou deseja salvar apenas os itens já preenchidos mantendo os demais campos sem preenchimento?',
            notificacaoAlteracoesNaoSalvas: 'Há alterações que não foram salvas, gostaria de salvar?',
          },
        },
      },
    },
  },

  folhaDePagamento: {
    pisPasepHelper:
      'Código de incidência relacionado ao recolhimento de encargos destinados ao Programa de Integração Social (PIS) ou ao Programa de Formação do Patrimônio do Servidor Público (PASEP)',
    rubrica: {
      alerta: {
        excecao:
          'Caso possua processo administrativo ou judicial com decisão/sentença favorável, determinando a não incidência de encargos relativos à rubrica, as informações serão exibidas aqui com o detalhamento do processo registrado através de evento específico (S-1070).',
      },
      dialog: {
        excecao:
          'Após esclarecer as informações com o cliente sobre a rubrica em questão, preencha os campos abaixo para efetuar o registro sobre casos de exceção não registrados no S-1070',
      },
      tabItem: {
        informacoes: {
          notificacaoAnaliseInvalida:
            'Você sinalizou o item como analisado, no entanto, há campos de análise obrigatórios sem preenchimento. <br> Proceda com o preenchimento dos campos faltantes ou altere a etapa de análise se deseja salvar.',
          notificacaoAnaliseIncompleta:
            'Identificamos campos sem preenchimento <strong>({campos})</strong>, gostaria de continuar as análises e preencher os itens faltantes ou deseja salvar apenas os itens já preenchidos mantendo os demais campos sem preenchimento?',
          notificacaoAlteracoesNaoSalvas: 'Há alterações que não foram salvas, gostaria de salvar?',
        },
      },
    },
    empregadores: {
      title: 'Empregadores',
      subtitle: 'Visualize dados dos empregadores registrados no eSocial',
      fieldNotFilled: 'Campo sem preenchimento no xml',
      missingUnknowEvent: 'Ausência de evento de admissão, desligamento ou afastamento.',
    },
    tabitem: {
      risco: {
        graficoHelper:
          'O gráfico de riscos considera apenas os itens analisados e que possuem algum risco relacionado. Os itens com risco são distribuídos de acordo com o grau de risco, para mais detalhes quanto os critérios de classificação de risco acesse a matriz de exposição.',
      },
    },
  },

  certificate: {
    status: {
      COLETA_DESABILITADA: {
        name: 'N/A',
        orientation: `{'A coleta de certidões para este CNPJ esta desabilitada. Caso tenha dúvidas ou deseje habilitar contate nosso time em ${emailSuporte}.'}`,
      },

      CERTIDAO_INDISPONIVEL: {
        name: 'N/A',
        orientation: `{'Não foi possível emitir a certidão. Realizaremos novas tentativas de coleta. Em caso de dúvidas ou se desejar orientações adicionais contate ${emailSuporte}.'}`,
      },

      CERTIDAO_ENCONTRADA: {
        name: 'N/A',
        orientation: 'Certidão emitida com sucesso, você pode baixá-la no ícone de download no menu de ações.',
      },

      CERTIDAO_EMITIDA: {
        name: 'N/A',
        orientation: 'Certidão emitida com sucesso, você pode baixá-la no ícone de download no menu de ações.',
      },

      CERTIDAO_NAO_EMITIDA: {
        name: 'N/A',
        orientation: `{'Não foi possível emitir a certidão, consulte o relatório de situação fiscal para visualizar as pendências sinalizadas pela RFB. Em caso de dúvidas ou se desejar orientações adicionais contate ${emailSuporte}.'}`,
      },

      SITUACAO_CADASTRAL_IMPEDITIVA: {
        name: 'N/A',
        orientation: `Não foi possível emitir a certidão, foi sinalizado a existência de situação cadastral impeditiva. Entre em contato com nossos especialistas mediante ${emailSuporte}.`,
      },

      ANALISE_INCONSISTENTE: {
        name: 'Análise inconsistente',
        orientation: `{'Não foi possível emitir a certidão, foi sinalizado que durante a tentativa de emissão estava ocorrendo alguma atualização de base de dados da RFB. Realizaremos novas tentativas de coleta assim que o ambiente estiver normalizado. Em caso de dúvidas ou se desejar orientações adicionais contate ${emailSuporte}.'}`,
      },

      BASE_APOIO_INDISPONIVEL: {
        name: 'Alguma base de apoio à verificação do contribuinte está indisponível',
        orientation: `{'Não foi possível emitir a certidão, foi sinalizado a indisponibilidade de um dos sistemas necessários para a emissão de certidão durante o processamento da requisição. Realizaremos novas tentativas de coleta assim que o ambiente estiver normalizado. Em caso de dúvidas ou se desejar orientações adicionais contate ${emailSuporte}.'}`,
      },

      EM_PROCESSAMENTO: {
        name: 'Chave de consulta em processamento',
        orientation: `{'Não foi possível emitir a certidão, foi sinalizado instabilidade sistêmica durante o processamento do pedido de emissão da certidão. Realizaremos novas tentativas de coleta assim que o ambiente estiver normalizado. Em caso de dúvidas ou se desejar orientações adicionais contate ${emailSuporte}.'}`,
      },

      PROCURACAO_NAO_ENCONTRADA: {
        name: 'N/A',
        orientation:
          'Não foi possível emitir a certidão porque não há a procuração necessária para consultar dados fiscais. Verifique a situação da procuração.',
      },
    },
  },
  encargosDctf: {
    detalhes: {
      modalCompensacao: {
        tooltip: 'Ver número PERD/COMP',
        title: 'Detalhes da Compensação',
        numeroPerdComp: 'Número da PERD/COMP:',
      },
    },
  },
};
